import { render, staticRenderFns } from "./base-card-v2.vue?vue&type=template&id=589937d0&scoped=true"
import script from "./base-card-v2.vue?vue&type=script&lang=js"
export * from "./base-card-v2.vue?vue&type=script&lang=js"
import style0 from "./base-card-v2.vue?vue&type=style&index=0&id=589937d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589937d0",
  null
  
)

export default component.exports